<template>
    <div>
        <div class="content-header">
            <h3>订单查询</h3>
            <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
                <el-form-item label="订单状态">
                    <el-select v-model="formInline.orderStatus"
                               filterable
                               clearable
                               onchange="">
                        <el-option v-for="item in orderStatus"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>

                </el-form-item>

                <el-form-item label="开始日期">
                    <el-date-picker
                            v-model="formInline.pay_time_range.begin_time"
                            type="datetime"
                            placeholder="不选择默认查询当天">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束日期">
                    <el-date-picker
                            v-model="formInline.pay_time_range.end_time"
                            type="datetime"
                            placeholder="选择结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getQueryOrderList">查询</el-button>
                </el-form-item>

            </el-form>
        </div>
        <div class="content-wrap">
            <el-table :data="dataList" stripe border center :size="GCONFIG.styleTableSize" row-click="">
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column label="主订单号" prop="orderMainNo"></el-table-column>
                <el-table-column label="支付金额" prop="payAmount"></el-table-column>
                <el-table-column label="下单时间" prop="createTime">
                </el-table-column>
                <el-table-column prop="order.merchantTradeNo" label="交易单号"></el-table-column>
                <el-table-column prop="order.orderState" label="订单状态">
                    <template slot-scope="scope">
                        <el-tag size="mini" v-if="scope.row.order.orderState==1" effect="plain">待发货</el-tag>
                        <el-tag size="mini" v-if="scope.row.order.orderState==2" type="success" effect="plain">已发货</el-tag>
                        <el-tag size="mini" v-if="scope.row.order.orderState==3" type="success" effect="plain">确认收货</el-tag>
                        <el-tag size="mini" v-if="scope.row.order.orderState==4" type="success" effect="plain">交易完成</el-tag>
                        <el-tag size="mini" v-if="scope.row.order.orderState==5" type="success" effect="plain">已退款</el-tag>
                        <el-tag size="mini" v-if="scope.row.order.orderState==6" type="success" effect="plain">资金待结算</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="statusClassName" label="订单类型"></el-table-column>
                <el-table-column prop="statusName" label="订单状态"></el-table-column>
                <el-table-column prop="createTime" label="创单时间"></el-table-column>
                <el-table-column label="操作" fixed="right" width="220">
                    <template slot-scope="scope">
                        <el-button-group>
                            <el-button type="warn" size="mini" @click="hideOrder(scope.row.orderMainNo)">隐藏订单</el-button>
                            <el-button type="success" size="mini" @click="handleDetail(scope.row.customerId)">客户详情</el-button>
                            <el-button type="primary" size="mini" @click="toOrderDetail(scope.row.orderMainNo)">订单详情</el-button>
                            <el-button type="success" size="mini" @click="syncOMSOrder(scope.row.orderMainNo)">同步OMS</el-button>
                            <el-button type="success" size="mini" @click="syncStatusEdbOrder(scope.row.orderMainNo)">同步支付成功</el-button>
                        </el-button-group>

                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrap">
                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="formInline.currentPage"
                        :page-sizes="GCONFIG.pageSizes"
                        :page-size="formInline.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="recordsTotal">
                </el-pagination>
            </div>
            <el-table :data="itemdataList" stripe border center :size="GCONFIG.styleTableSize">
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column label="子订单号" prop="orderNo"></el-table-column>
                <el-table-column label="电话" prop="consigneePhone"></el-table-column>
                <el-table-column label="收件人" prop="consigneeName"></el-table-column>
                <el-table-column label="收货地址" prop="payAmount">
                    <template slot-scope="scope">
                        <span>{{consigneeProvincename+','+consigneeCityname+','+consigneeCityname+','+consigneeCityname}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="下单时间" prop="createTime">
                </el-table-column>
                <el-table-column prop="order.merchantTradeNo" label="交易单号"></el-table-column>
                <el-table-column prop="order.orderState" label="订单状态">
                    <template slot-scope="scope">
                        <el-tag size="mini" v-if="scope.row.order.status==3" effect="plain">待发货</el-tag>
                        <el-tag size="mini" v-if="scope.row.order.orderState>=3&&scope.row.order.orderState<16" type="success" effect="plain">已发货</el-tag>
                        <el-tag size="mini" v-if="scope.row.order.orderState>=16&&scope.row.order.orderState<20" type="success" effect="plain">确认收货</el-tag>
                        <el-tag size="mini" v-if="scope.row.order.orderState>=20" type="success" effect="plain">已退款</el-tag>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {shippingOrderList} from '@/api/api';
    //定义组件
    export default {
        data() {
            return {
                dataList: [],
                expireTimeOPtion: {
                    disabledDate(time) {
                        //如果没有后面的 - 8.64e7 只能选择大于今天的。
                        //time.getTime() < Date.now() - 8.64e7
                        //只能选择小于等于今天的
                        //time.getTime() > Date.now()
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                orderStatus:[{id:1,name:'待发货'},{id:2,name:'已发货'},{id:3,name:'确认收货'},{id:4,name:'交易完成'},{id:5,name:'已退款'},{id:6,name:'资金待结算'}],
                itemdataList:[],
                formInline: {
                    pay_time_range:{
                        begin_time:Date.now() - 2 * 24 * 60 * 60 * 1000 ,
                        end_time:Date.now()
                    },
                    order_state: 1,
                    openid:'',
                    last_index:'',
                    page_size:50
                },
                recordsTotal:0,
                drawerShow:false,
                toUrl:''
            }
        },
        //挂载时候执行
        mounted() {
            this.getQueryOrderList();
        },
        methods: {
            //定义查询方法
            getQueryOrderList() {
                this.loading = true;
                shippingOrderList(this.formInline).then((res) => {
                    this.dataList = res.data.value.shipOrderList
                    this.itemdataList=this.dataList[0].orderItemList
                    this.loading = false;
                })
            },
            rowSelectData(row, column, event){
                this.itemdataList=row.orderItemList
            },
            getDefaultBegin(){
                const currentTimestamp = Date.now();
                // 计算两天前的时间戳
                const twoDaysAgoTimestamp = currentTimestamp - 2 * 24 * 60 * 60 * 1000;
                return twoDaysAgoTimestamp;
            },
            GetQueryString(name){
                let reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
                let sp = '?'
                let arr=window.location.href.split(sp);
                if(arr.length>=2){
                    let u=arr[1].substr(1);
                    u= u.replace(/amp;/g,"");
                    let r = u.match(reg);
                    if(r!=null)
                        return  decodeURIComponent(r[2]);
                }
                return(false);
            }
        }
    }
</script>
<style scoped lang="scss" rel="stylesheet/scss" >
    .select-wrap{
        margin: 10px 10px 0 10px;
    }
</style>



// WEBPACK FOOTER //
// src/views/order/shipOrder.vue